<template>
  <div class="pageStyle">
    <div class="top-bg"></div>
    <div class="top-title">
      <div>
        <span> 夹层码工具 </span>
        <span>自定义生成、管理进件夹层码</span>
      </div>
      <div>
        <img
          src="https://static.xchengtech.cn/5927dc560b8048dc87ede7a09c175670.png"
          alt=""
        />
      </div>
    </div>
    <div class="header">
      <div class="item">
        <van-search
          v-model="params.layerName"
          placeholder="搜索夹层码名称"
          show-action
          @search="onSearch"
          ><template #action>
            <div @click="onSearch">搜索</div>
          </template>
        </van-search>
      </div>
      <div class="item">
      </div>
    </div>
    <div class="content">
      <div class="title">
        <div>
          <span>夹层码列表</span> <span>总数{{ dataList.length }}个</span>
        </div>
        <div>
          <span @click="toPage('layerCodeForm')">新增夹层码</span>
        </div>
      </div>
      <div class="codeList">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div
            class="codeCard-item"
            v-for="(item, index) in dataList"
            :key="index"
          >
            <div class="item" @click="openQrCode(item.id)">
              <!-- 二维码 -->
              <div :id="'qrCodeItem' + index" :ref="'qrCodeItem' + index">
                <img :src="item.qrCodeImage" alt="" />
              </div>
              <div
                :style="{
                  backgroundColor: item.backgroundColor,
                  color: item.fontColor,
                }"
              >
                <!-- 标题 -->
                <span>
                  {{ item.layerName }}
                </span>
                <!-- 备注 -->
                <span v-show="item.notes">{{ item.notes }}</span>
              </div>
            </div>
            <div class="item">
              <div class="items">
                <span>{{ item.layerName }}</span
                ><span
                  ><van-switch
                    v-model="item.isEnabled"
                    size="4.6vw"
                    :active-value="1"
                    :inactive-value="0"
                    @change="switchChange(item)"
                /></span>
              </div>
              <div class="items">
                <span v-show="item.upstreamName"
                  >上游：<s>{{ item.upstreamName }}</s></span
                ><span
                  >经过夹层：<s>{{ item.isPassed ? "是" : "否" }}</s></span
                >
              </div>
              <div class="items">
                <span @click="toDataList(item)">夹层数据</span
                ><span @click="toEdit(item)">编辑</span
                ><span @click="toDel(item)">删除</span>
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </div>
    <!-- 二维码弹窗 -->
    <van-dialog v-model="qrCodeShow" :showConfirmButton="false">
      <div class="qrCodeShow">
        <img :src="qrCodeShowImg" alt="" />
        <div class="closeIcon">
          <van-icon
            name="close"
            size="12vw"
            @click="qrCodeShow = !qrCodeShow"
          />
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import {
  getXcLayerCode,
  delXcLayerCode,
  editXcLayerCode,
  getXcLayerCodeImg,
} from "@/api/layerCode.js";
import Vue from "vue";
import QRCode from "qrcodejs2";
import { Search, Switch, Toast, Notify, Dialog, Icon, List } from "vant";
Vue.use(Search);
Vue.use(Switch);
Vue.use(Toast);
Vue.use(Notify);
Vue.use(Dialog);
Vue.use(Icon);
Vue.use(List);
export default {
  components: {},
  watch: {
    dataList: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue && newValue.length > 0) {
          this.$nextTick(() => {
            newValue.forEach((item, index) => {
              let qrCode = document.getElementById("qrCodeItem" + index);
              // 正式环境
              let url =
                "https://independentpage.xchengtech.cn/layerCode.html?code=" +
                item.id;
              qrCode.innerHTML = "";
              new QRCode(qrCode, {
                text: url,
                width: 54,
                height: 54,
                colorDark: "#333333", // 二维码颜色
                colorLight: "#ffffff", // 二维码背景色
                correctLevel: QRCode.CorrectLevel.L, // 容错率，L/M/H
              });
            });
          });
        }
      },
      deep: true,
    },
  },
  created() {
    // Toast.loading({
    //   message: "加载中...",
    //   forbidClick: true,
    //   duration: 0,
    // });
    // this.getData();
  },
  data() {
    return {
      loading: false,
      finished: false,
      checked: true,
      qrCodeShow: false,
      qrCodeShowImg: "",
      params: {
        layerName: "",
        size: 10,
        page: 0,
        sort: "id,desc",
      },
      dataList: [],
    };
  },

  mounted() {},

  methods: {
    getData() {
      if (!this.params.layerName) delete this.params.layerName;
      getXcLayerCode(this.params).then((res) => {
        Toast.clear();
        this.dataList = this.dataList.concat(res.content);
        this.params.page++;
        this.loading = false;
        if (res.content.length == 0) {
          this.finished = true;
        }
      });
    },
    onLoad() {
      this.loading = true;
      this.getData();
    },
    onSearch() {
      this.finished = false;
      this.loading = true;
      this.dataList = [];
      this.params.page = 0;
      this.getData();
    },
    // 上下架状态
    switchChange(item) {
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
      });
      editXcLayerCode(item).then((res) => {
        Toast.clear();
        if (item.isEnabled === 1) {
          Notify({
            type: "success",
            message: "夹层码：" + item.layerName + " 已上架",
          });
        } else {
          Notify({
            type: "success",
            message: "夹层码：" + item.layerName + " 已下架",
          });
        }
      });
    },
    toPage(name) {
      this.$router.push({ path: "/" + name });
    },
    toDel(item) {
      Dialog.confirm({
        title: "提示",
        message: "是否确认删除夹层码：" + item.layerName,
      })
        .then(() => {
          // on close
          Toast.loading({
            message: "加载中...",
            forbidClick: true,
            duration: 0,
          });
          delXcLayerCode(item.id).then((res) => {
            Notify({ type: "success", message: "删除成功" });
            this.params.page = 0;
            this.onSearch();
          });
        })
        .catch(() => {
          // on cancel
        });
    },
    toDataList(item) {
      this.$router.push({
        path: "/layerCodeDataList",
        query: { code: item.id },
      });
    },
    toEdit(item) {
      this.$router.push({
        path: "/layerCodeForm",
        query: { code: item.id },
      });
    },
    openQrCode(id) {
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        overlay: true,
        duration: 0,
      });
      getXcLayerCodeImg(id).then((res) => {
        this.qrCodeShow = !this.qrCodeShow;
        this.qrCodeShowImg = res.url;
        Toast.clear();
      });
    },
  },
};
</script>
<style scoped>
.pageStyle {
  position: relative;
  height: 100%;
  font-size: 4vw;
}

.top-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 80vw;
  background-image: linear-gradient(to bottom, #1b5dd9 50%, white 100%);
  z-index: -1;
}

.top-title {
  position: relative;
  display: flex;
  justify-content: space-between;
  padding: 8vw 0;
  color: white;
  padding-left: 4vw;
}

.top-title div:nth-of-type(1) {
  display: grid;
  gap: 2vw;
}

.top-title div:nth-of-type(1) span:nth-of-type(1) {
  letter-spacing: 4px;
  font-weight: 600;
  font-size: 8vw;
  /* color: #4988fd; */
}

.top-title div:nth-of-type(1) span:nth-of-type(2) {
  /* font-weight: 600; */
  font-size: 4vw;
  /* color: #4988fd; */
}

.top-title div:nth-of-type(2) {
  position: absolute;
  top: 0;
  right: 0;
  height: 40vw;
}

.top-title div:nth-of-type(2) img {
  height: 100%;
  opacity: 0.6;
}

.header {
  padding: 0 4vw;
}

.header .item:nth-of-type(1) .van-search {
  /* padding: 2vw 0; */
  border-radius: 8px;
  font-size: 4vw;
}

.header .item:nth-of-type(1) .van-search__content {
  background-color: white;
  border-radius: 8px;
  padding-left: 0;
}

.header .item:nth-of-type(1) .van-search__action {
  padding-right: 4vw;
}

.header .item:nth-of-type(1) .van-field {
  font-size: 4vw;
}

.header .item:nth-of-type(1) /deep/ .van-icon {
  margin-right: 1vw;
  font-size: 5vw;
  font-weight: 600;
  color: #6b6b6b;
}

.header .item:nth-of-type(2) {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 4vw;
}

.header .item:nth-of-type(2) .items {
  padding: 3vw 2vw 3vw 3vw;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  background-image: linear-gradient(120deg, #e7f1fe 0%, #ffffff 100%);
  /* box-shadow: 0 4px 12px rgba(0,0,0,.1); */
}

.header .item:nth-of-type(2) .items div:nth-of-type(1) span {
  display: block;
}

.header .item:nth-of-type(2) .items div:nth-of-type(1) span:nth-of-type(1) {
  font-weight: 700;
  font-size: 4.6vw;
  color: #1b67cc;
}

.header .item:nth-of-type(2) .items div:nth-of-type(1) span:nth-of-type(2) {
  color: #7d96bc;
  font-size: 3.6vw;
}

.header .item:nth-of-type(2) .items div:nth-of-type(1) {
  display: grid;
  gap: 1vw;
}

.header .item:nth-of-type(2) .items div:nth-of-type(2) {
  display: flex;
  align-items: flex-end;
}

.header .item:nth-of-type(2) img {
  display: block;
  width: 14vw;
  height: 14vw;
}

.content {
  padding: 4vw 0;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,.1);
  overflow: hidden;
  margin: 4vw;
}

.content .title {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 2vw;
  border-bottom: 1px solid #ebedf0;
  padding: 0 4vw 2vw 4vw;
  /* padding-bottom: 4vw; */
}

.content .title div:nth-of-type(1) span:nth-of-type(1) {
  font-size: 5vw;
  color: #333;
  font-weight: 600;
}

.content .title div:nth-of-type(1) span:nth-of-type(2) {
  color: #2180ff;
  font-weight: 600;
}
.content .title div:nth-of-type(1) {
  display: flex;
  align-items: end;
  gap: 3vw;
}
.content .title div:nth-of-type(2) {
  display: flex;
  align-items: baseline;
  gap: 4px;
}

.content .title div:nth-of-type(2) span {
  font-size: 4vw;
  font-weight: 600;
}

.content .codeList {
  display: grid;
  gap: 4vw;
  padding: 0 4vw;
}

.content .codeList .codeCard-item {
  background-color: white;
  display: flex;
  gap: 4vw;
  align-items: center;
  padding: 4vw 0;
  border-bottom: 1px solid #ebedf0;
}

.content .codeList .codeCard-item .item:nth-of-type(1) div:nth-of-type(1) {
  padding: 1vw;
}

.content .codeList .codeCard-item .item:nth-of-type(1) div:nth-of-type(2) {
  display: grid;
  gap: 1px;
  padding: 1vw 1vw;
  font-size: 1.6vw;
  text-align: center;
}

.content
  .codeList
  .codeCard-item
  .item:nth-of-type(1)
  div:nth-of-type(2)
  span:nth-of-type(2) {
  font-size: 0.6vw;
}

.content .codeList .codeCard-item .item:nth-of-type(1) img {
  display: block;
  width: 14vw;
  height: 14vw;
}

.content .codeList .codeCard-item .item:nth-of-type(2) {
  width: 100%;
  display: grid;
  gap: 1vw;
}

.content .codeList .codeCard-item .item:nth-of-type(2) .items:nth-of-type(1) {
  display: flex;
  justify-content: space-between;
}

.content
  .codeList
  .codeCard-item
  .item:nth-of-type(2)
  .items:nth-of-type(1)
  span:nth-of-type(1) {
  font-weight: 600;
  font-size: 4.6vw;
}

.content .codeList .codeCard-item .item:nth-of-type(2) .items:nth-of-type(2) {
  display: flex;
  gap: 3vw;
  font-size: 3.6vw;
}

.content .codeList .codeCard-item .item:nth-of-type(2) .items:nth-of-type(2) s {
  color: #2180ff;
  text-decoration: none;
}

.content .codeList .codeCard-item .item:nth-of-type(2) .items:nth-of-type(3) {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2vw;
  padding-top: 1vw;
}

.content
  .codeList
  .codeCard-item
  .item:nth-of-type(2)
  .items:nth-of-type(3)
  span {
  border: 1px solid grey;
  border-radius: 4px;
  padding: 1.2vw 0;
  font-size: 3.4vw;
  text-align: center;
}

.content
  .codeList
  .codeCard-item
  .item:nth-of-type(2)
  .items:nth-of-type(3)
  span:nth-of-type(2) {
  color: #fff;
  background-color: #07c160;
  border: 1px solid #07c160;
}

.content
  .codeList
  .codeCard-item
  .item:nth-of-type(2)
  .items:nth-of-type(3)
  span:nth-of-type(3) {
  color: #fff;
  background-color: #ee0a24;
  border: 1px solid #ee0a24;
}

.qrCodeShow {
  position: relative;
}

.qrCodeShow img {
  width: 100%;
}

.qrCodeShow .closeIcon {
  position: absolute;
  bottom: -23vw;
  left: 0;
  display: flex;
  width: 100%;
  justify-content: center;
}

.qrCodeShow .closeIcon .van-icon {
  color: white;
}

.van-dialog {
  background-color: rgba(0, 0, 0, 0);
  overflow: visible;
}

.van-overlay {
  background-color: white;
}
</style>



// WEBPACK FOOTER //
// src/view/layerCode/index.vue